import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { DEFAULT_CONTENT } from "../data/defaults";

function deepMerge(base, over) {
  if (over === undefined || over === null || over === "") return base;
  if (Array.isArray(over)) return over.length ? over : base;
  if (typeof over === "object") {
    const out = { ...(base && typeof base === "object" && !Array.isArray(base) ? base : {}) };
    for (const k of Object.keys(over)) {
      out[k] = deepMerge(base ? base[k] : undefined, over[k]);
    }
    return out;
  }
  return over;
}

const Ctx = createContext({ content: DEFAULT_CONTENT, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(deepMerge(DEFAULT_CONTENT, data));
    } catch {
      /* keep defaults */
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <Ctx.Provider value={{ content, reload }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
